/**
*
*   Customer Provider
*       - Override the Next-intl Navigation
*
**/
'use client';

import CustomerAPI from '@/libraries/shopify-customer/class';
import Customer from '@/libraries/customer';
import { createContext, useState } from 'react';
import { useRouter } from 'next/navigation';

//The Cart Context
export const CustomerContext = createContext(null);

//Create the Cart Context
function CustomerProvider({ data , session , children }){

	//Load the Router
	const router = useRouter();

	//The Store Data
	const [customer, setCustomer] = useState(data);

	//Is the Customer Loading
	Customer.loading = false;

	//For the Customer API Library
	Customer.api = session?.accessToken ? CustomerAPI( session.accessToken ) : null ;

	//
	Customer.is = {

		//Default settings
		...customer.is,

		//Is the Customer Wholesale
		wholesale: (type) => {

			//Return generic wholesale comparison
			if( !type ) return ( customer?.is ? customer.is.wholesale : false );

			//Return wholesale type comparison
			return customer.tags.filter( tag => tag.toLowerCase().indexOf( type.toLowerCase() ) > -1 ).length > 0;

		},

		//Is the customer logged in
		loggedin: 	() => session

	};

	//Get's the Customer Username. Defaults to Username field, Fallback to first + last and then Display Name
	Customer.getDisplayName = () => ( customer.username?.value || ( customer.firstName ? `${ customer.firstName  } ${  customer.lastName }` : customer.displayName ) );

	//Add the Get field to the Customer object
	Customer.get = (callback) => {
		try {
			return callback(customer);
		} catch(e){
			return false;
		}
	};

	Customer.set = (data) => setCustomer({
		...customer,
		...data
	});

	//Return the Provider
	return (
		<CustomerContext.Provider value={{ Customer }}>
			{children}
		</CustomerContext.Provider>
	);
}

export default CustomerProvider;